<template>
    <div class="card p-2 px-lg-3 py-xl-2">
        <div class="d-flex align-items-center justify-content-between gap-4">
            <h6 class="mb-0">{{ product.name }}</h6>
            <basic-button
                class="btn btn-secondary btn-sm"
                :disabled="installed"
                :loading="installing"
                @click="install"
                :text="trans(`general.defaults.${installed ? 'using' : 'use'}`)"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductCardInline",
    props: {
        product: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            installed: false,
            installing: false,
        }
    },
    methods: {
        checkIfInstalled() {
            axios.get(`/store-products/variant/${this.product.id}/installed`)
                .then((result) => {
                    this.installed = result.data.data.installed;
                });
        },
        install() {
            this.installing = true;
            axios.post(`/store-products/variant/${this.product.variant.id}/install`)
                .then(response => {
                    this.installing = false;
                    this.installed = response.data.data.installed;
                    this.$notify({
                        type: 'success',
                        text: trans('general.defaults.form_in_use')
                    });
                    this.$emit('installed', this.model);
                })
                .catch(error => {
                    this.installing = false;
                });
        },
    },
    mounted() {
        this.checkIfInstalled();
    }
}
</script>
